import { useLayoutEffect, useState, createContext } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { refreshAccessToken, fetchWithAuth, debug_mode } from "./Utils"
import logo from "./img/loghi/logo-trasparente.png"
import "./Main.css"
import Navbar from './componenti/Navbar'
import Footer from './componenti/Footer'
import Home from './Home'
import Login from './Login'
import Prenota from './Prenota'
import Profilo from './Profilo'
import Sudinoi from './Sudinoi'
import Privacy from "./Privacy"
import Gestione from './Gestione';
import Alert from './componenti/Alert';
import ClassificaMobile from './ClassificaMobile';

export const Account = createContext()

const Main = () => {
    const [persona, setpersona] = useState({ 
        email: "", nome: "", cognome: "", username: "", 
        nascita: "", socio: false, maestro: false, 
        access_token: null, sfide_presenti:false
    });
    const [alert, setAlert] = useState({
        titolo: "",
        messaggio: "",
        durata: 0,
        onClose: () => setAlert({ titolo: "", messaggio: "" })
    });
    const [loading, setLoading] = useState(true);

    const showAlert = (titolo = "Attenzione", messaggio = "", durata = 1500) =>{
        if(debug_mode) console.log("Show Alert: ",messaggio, durata)
        setAlert({
            titolo,
            messaggio,
            durata,
            onClose: () => setAlert({ titolo: "", messaggio: "" })
        })
    } 

    useLayoutEffect(() => {
        // SPLASHSCREEN
        if (document.querySelector("#splashscreen") != null) {
            setTimeout(() => {
                let spl = document.querySelector("#splashscreen");
                if(spl != null)
                    spl.style.opacity = "0"
            }, 1000);
            setTimeout(() => {
                let spl = document.querySelector("#splashscreen");
                if(spl!=null)
                    spl.style.display = "none"
            }, 1200);
        }

        // Verifica token salvato
        const token = localStorage.getItem("access_token");
        
        if (token && token !== undefined && token != "undefined") {
            verificaToken(token);
            verificaSfideInAttesa();
        } else {
            setLoading(false);
        }
    }, [])

    const verificaSfideInAttesa = async () => {
        try {
            const res = await fetchWithAuth("classifica_mobile_get_sfide.php",{},"GET");

            if (res.ok) {
                setpersona(prev => ({
                    ...prev,
                    sfide_presenti: res.nuove
                }));
            }
        } catch (e) {
            if (debug_mode) console.error("Errore verifica sfide:", e);
        }
    };

    const verificaToken = async (token) => {
        try {
            const data = await fetchWithAuth("verifica_token.php");
            if (data.ok) {
                setpersona(prev => ({
                    ...prev,
                    ...data.user,
                    access_token: token,
                }));
            } else {
                const new_token = await refreshAccessToken();

                if (new_token != undefined && new_token != "undefined" && new_token !== "") {
                    setpersona(prev => ({
                        ...prev,
                        access_token: new_token,
                    }));
                    logout();
                }
            }
        } catch (error) {
            console.error("Errore verifica token:", error);
            const new_token = await refreshAccessToken();
            if (new_token !== "" && new_token != "undefined") {
                localStorage.setItem("access_token", new_token);
                setpersona(prev => ({
                    ...prev,
                    access_token: new_token,
                }));
            }
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            await fetchWithAuth("logout.php");
        } catch (error) {
            console.error("Errore logout:", error);
        }

        localStorage.clear();
        sessionStorage.clear();
        setpersona({ 
            email: "", nome: "", cognome: "", username: "", 
            nascita: "", socio: false, maestro: false, 
            access_token: null 
        });
        window.location.reload();
    };

    // logout globale
    const logoutAllDevices = async () => {
        try {
            const data = await fetchWithAuth("logout_all.php");
            if (data.ok) {
                localStorage.clear();
                localStorage.clear();
                setpersona({ 
                    email: "", nome: "", cognome: "", username: "", 
                    nascita: "", socio: false, maestro: false, 
                    access_token: null 
                });
                window.location.reload();
            }
        } catch (error) {
            console.error("Errore logout all devices:", error);
        }
    };

    if (loading) {
        return (
            <div id="splashscreen">
                <div id="racchetta"></div>
                <div className='logo'>
                    <img src={logo} alt="logo"/>
                </div>
            </div>
        );
    }

    return (
        <Account.Provider value={{ persona, setpersona, logout, logoutAllDevices, showAlert }}>
            <Router>
                <div>
                    <Navbar/>
                    <Alert object={alert}/>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/login" element={!persona.access_token ? <Login/> : <Home/>}/>
                        <Route path="/prenota" element={persona.access_token ? <Prenota/> : <Login/>}/>
                        <Route path="/profilo" element={persona.access_token ? <Profilo/> : <Login/>}/>
                        <Route path="/su-di-noi" element={<Sudinoi/>}/>
                        <Route path="/privacy" element={<Privacy/>}/>
                        <Route path="/classifica-mobile" element={<ClassificaMobile/>}/>
                        <Route path="/gestione" element={persona.access_token && persona.maestro ? <Gestione/> : <Home/>}/>
                    </Routes>
                    <Footer/>
                </div>
            </Router>
        </Account.Provider>
    )
}

export default Main
